import { useState } from "react";
import apiClient from "@/services/apiClient";
import { useNavigate } from "react-router-dom";
import { Shield, Lock, Mail } from "lucide-react";
import ToastHelper from "@/utils/toastHelper";

export default function AdminLogin() {
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const apiBaseUrl = (process.env.REACT_APP_API_URL).replace(/\/$/, "");
      const response = await apiClient.post(`${apiBaseUrl}/AdminLogin/login`, {
        email: f.email,
        password: f.password,
      });

      if (response.data?.success === true || response.data?.statusCode === 1 || response.status === 200) {
        if (response.data?.token) {
          localStorage.setItem("token", response.data.token);
        }

        ToastHelper.success(response.data?.message || "Signed in as Super Admin");
        setTimeout(() => nav("/admin/dashboard"), 400);
      } else {
        ToastHelper.error(response.data?.message || "Login failed");
      }
    } catch (err) {
      console.error("Admin login failed", err);
      ToastHelper.apiError(err, "Unable to login. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16 bg-slate-50 -mx-4">
      <div className="w-full max-w-md">
        <div className="wc-card p-8 bg-white border-slate-200">
          <div className="w-14 h-14 rounded-2xl bg-[#0A2540] text-white flex items-center justify-center mb-5 mx-auto"><Shield className="w-6 h-6" /></div>
          <h1 className="text-2xl font-display font-extrabold text-[#0A2540] text-center">Admin Portal</h1>
          <p className="text-sm text-slate-500 text-center mt-1 mb-6">Restricted access — sign in with your admin credentials.</p>
          <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
            <div><label className="wc-label">Email</label>
              <div className="relative"><Mail className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
                <input required type="email" className="wc-input pl-9" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="admin-login-email" /></div>
            </div>
            <div><label className="wc-label">Password</label>
              <div className="relative"><Lock className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
                <input required type="password" className="wc-input pl-9" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="admin-login-password" /></div>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 rounded-lg bg-[#0A2540] hover:bg-[#123057] text-white font-semibold transition-colors disabled:opacity-70"
              data-testid="admin-login-submit"
            >
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
